<template>
    <div class="warp">
        <div class="left">
            <el-menu v-if="list && list.length !== 0"
                :default-active="defaultActive"
                router
                class="el-menu-vertical-demo"
                :background-color="variables.menuBg"
                :text-color="variables.menuText"
                :active-text-color="variables.menuActiveText">
                <!-- <el-menu-item index="/">
                    <i class="el-shouye"></i>
                    <span slot="title">首页</span>
                </el-menu-item>
                <el-submenu index="2">
                    <template slot="title">
                    <i class="el-shenhe"></i>
                    <span>审核管理</span>
                    </template>
                        <el-menu-item-group>
                            <el-menu-item index="/auditsManagement/user">用户认证审核</el-menu-item>
                            <el-menu-item index="/auditsManagement/applicationDebt">债权融资申请审核</el-menu-item>
                            <el-menu-item index="/auditsManagement/releaseDebt">债权融资发布审核</el-menu-item>
                            <el-menu-item index="/auditsManagement/applicationFinancial">融资租赁申请审核</el-menu-item>
                            <el-menu-item index="/auditsManagement/releaseFinancing">融资租赁公司发布审核</el-menu-item>
                            <el-menu-item index="/auditsManagement/releaseEquity">股权融资发布审核</el-menu-item>
                            <el-menu-item index="/auditsManagement/guaranteeCorporation">担保公司发布审核</el-menu-item>
                            <el-menu-item index="/auditsManagement/applicationGuarantee">申请担保审核</el-menu-item>
                            <el-menu-item index="/auditsManagement/releaseIncubator">孵化器发布审核</el-menu-item>
                            <el-menu-item index="/auditsManagement/applicationIncubator">申请入驻孵化器审核</el-menu-item>
                            <el-menu-item index="/auditsManagement/releasePolicy">政策资讯发布审核</el-menu-item>
                            <el-menu-item index="/auditsManagement/releasePolicyDeclare">政策申报发布审核</el-menu-item>
                            <el-menu-item index="/auditsManagement/applicationPolicyDeclare">申请政策申报审核</el-menu-item>
                            <el-menu-item index="/auditsManagement/releaseNews">资讯发布审核</el-menu-item>
                            <el-menu-item index="/auditsManagement/applicationSalon">活动沙龙报名审核</el-menu-item>
                            <el-menu-item index="/auditsManagement/releaseSalon">活动沙龙发布审核</el-menu-item>
                            <el-menu-item index="/auditsManagement/releaseAgent">中介服务发布审核</el-menu-item>
                        </el-menu-item-group>
                </el-submenu>
                <el-submenu index="3">
                    <template slot="title">
                    <i class="el-yonghu"></i>
                    <span>用户管理</span>
                    </template>
                        <el-menu-item-group>
                            <el-menu-item index="/userManagement">用户列表</el-menu-item>
                        </el-menu-item-group>
                </el-submenu>
                <el-submenu index="4">
                    <template slot="title">
                    <i class="el-zhaiquan"></i>
                    <span>债权融资管理</span>
                    </template>
                        <el-menu-item-group>
                            <el-menu-item index="/debtManagement/productList">债权产品列表</el-menu-item>
                            <el-menu-item index="/debtManagement/companyList">融资租赁公司列表</el-menu-item>
                            <el-menu-item index="/debtManagement/applyList">融资租赁申请列表</el-menu-item>
                        </el-menu-item-group>
                </el-submenu>
                <el-submenu index="5">
                    <template slot="title">
                    <i class="el-guquanrongzi"></i>
                    <span>股权融资管理</span>
                    </template>
                        <el-menu-item-group>
                            <el-menu-item index="/equityManagement/productList">股权融资项目列表</el-menu-item>
                            <el-menu-item index="/equityManagement/applyList">基金合作申请列表</el-menu-item>
                        </el-menu-item-group>
                </el-submenu>
                <el-submenu index="6">
                    <template slot="title">
                    <i class="el-danbao"></i>
                    <span>担保服务管理</span>
                    </template>
                        <el-menu-item-group>
                            <el-menu-item index="/guaranteeManagement/companyList">其它担保公司列表</el-menu-item>
                            <el-menu-item index="/guaranteeManagement/otherApplyList">其它担保公司担保申请列表</el-menu-item>
                            <el-menu-item index="/guaranteeManagement/applyList">经开区中小担申请列表</el-menu-item>
                        </el-menu-item-group>
                </el-submenu>
                <el-submenu index="7">
                    <template slot="title">
                    <i class="el-fuhuaqi"></i>
                    <span>孵化器管理</span>
                    </template>
                        <el-menu-item-group>
                            <el-menu-item index="/incubatorManagement/incubatorList">孵化器列表</el-menu-item>
                            <el-menu-item index="/incubatorManagement/settledEnterprise">入驻企业</el-menu-item>
                        </el-menu-item-group>
                </el-submenu>
                <el-submenu index="8">
                    <template slot="title">
                    <i class="el-zhengce"></i>
                    <span>政策指引管理</span>
                    </template>
                        <el-menu-item-group>
                            <el-menu-item index="/policyManagement/message">政策资讯列表</el-menu-item>
                            <el-menu-item index="/policyManagement/declare">政策申报列表</el-menu-item>
                        </el-menu-item-group>
                </el-submenu>
                <el-submenu index="9">
                    <template slot="title">
                    <i class="el-zhongjie"></i>
                    <span>中介服务管理</span>
                    </template>
                        <el-menu-item-group>
                            <el-menu-item index="/agentManagement">中介服务列表</el-menu-item>
                        </el-menu-item-group>
                </el-submenu>
                <el-submenu index="10">
                    <template slot="title">
                    <i class="el-zixun"></i>
                    <span>资讯管理</span>
                    </template>
                        <el-menu-item-group>
                            <el-menu-item index="/messageManagement">资讯列表</el-menu-item>
                        </el-menu-item-group>
                </el-submenu>
                <el-submenu index="11">
                    <template slot="title">
                    <i class="el-huodong"></i>
                    <span>活动沙龙管理</span>
                    </template>
                        <el-menu-item-group>
                            <el-menu-item index="/salonManagement">活动列表</el-menu-item>
                        </el-menu-item-group>
                </el-submenu>
                <el-submenu index="12">
                    <template slot="title">
                    <i class="el-tongji"></i>
                    <span>数据统计</span>
                    </template>
                        <el-menu-item-group>
                            <el-menu-item index="/dataStatistics/user">用户统计</el-menu-item>
                            <el-menu-item index="/dataStatistics/debt">债权融资统计</el-menu-item>
                            <el-menu-item index="/dataStatistics/financial">融资租赁统计</el-menu-item>
                            <el-menu-item index="/dataStatistics/equity">股权融资统计</el-menu-item>
                            <el-menu-item index="/dataStatistics/guarantee">担保服务统计</el-menu-item>
                            <el-menu-item index="/dataStatistics/policy">政策指引统计</el-menu-item>
                            <el-menu-item index="/dataStatistics/incubator">孵化器统计</el-menu-item>
                            <el-menu-item index="/dataStatistics/message">资讯统计</el-menu-item>
                            <el-menu-item index="/dataStatistics/salon">活动沙龙统计</el-menu-item>
                            <el-menu-item index="/dataStatistics/agent">中介服务统计</el-menu-item>
                        </el-menu-item-group>
                </el-submenu>
                <el-submenu index="13">
                    <template slot="title">
                    <i class="el-set"></i>
                    <span>系统配置</span>
                    </template>
                        <el-menu-item-group>
                            <el-menu-item index="/systemLayout/administrator">管理员配置</el-menu-item>
                            <el-menu-item index="/systemLayout/character">角色权限管理</el-menu-item>
                            <el-menu-item index="/systemLayout/banner">发布banner</el-menu-item>
                            <el-menu-item index="/systemLayout/configuration/configurationFirst">前端配置</el-menu-item>
                            <el-menu-item index="/systemLayout/SMSManager">短信管理</el-menu-item>
                            <el-menu-item index="/systemLayout/dictionary">字典配置</el-menu-item>
                        </el-menu-item-group>
                </el-submenu> -->
                <el-menu-item :index="item.href" v-for="(item,index) in list" :key="index" v-if="item.href==='/'">{{item.permissionName}}</el-menu-item>
                <el-submenu :index="(index+'')" v-for="(item,index) in list" :key="index" v-if="item.href!=='/'">
                    <template slot="title">
                    <i :class="item.icon"></i>
                    <span>{{item.permissionName}}</span>
                    </template>
                        <el-menu-item-group v-if="item.sysPermissionVoList && item.sysPermissionVoList.length !== 0">
                            <el-menu-item :index="items.href" v-for="(items,indexs) in item.sysPermissionVoList" :key="'2-'+indexs">{{items.permissionName}}</el-menu-item>
                        </el-menu-item-group>
                </el-submenu>
            </el-menu>
        </div>
    </div>
</template>

<script>
import variables from '@/assets/variables.scss'
export default {
    data(){
        return{
            defaultActive:'',//活跃路由
            list:[],//数组
        }
    },
    computed:{
      variables() {
        return variables
      }
    },
    watch:{
        '$route'(to,from){
            if(to.query.index){
                this.defaultActive=to.query.index;
            }else{
                this.defaultActive=to.path;
            }
        }
    },
    methods:{
        // 获取选项卡列表
        getList:function(){
            this.$axiosz.get('/backstage/sysPermission/current').then((r)=>{
                if(r.code==200){
                    this.list=r.data;
                    
                    
                    this.$store.commit({
                        type:'left/getLeft',
                        leftList:this.list
                    })
                }else{
                    this.$alert(r.msg);
                }
            })
        }
    },
    created(){
        this.defaultActive=this.$route.path;
    },
    mounted(){
        if(this.$store.state.user.token){ //当登录后才发起请求
            this.getList();
        }
    }
}
</script>

<style lang="scss" scoped>
.warp{
    height: 100%;
    background: #fff;
    // background:linear-gradient(359deg,rgba(26,80,124,1) 0%,rgba(23,53,104,1) 32%,rgba(21,34,89,1) 100%);
    .left{
        width: 220px;
        /deep/ .el-submenu__title,/deep/ .el-menu-item{
            i{
                margin-right: 5px;
                color:#808695;
                font-size: 14px;
                // color: white;
            }
        }
    }
}
</style>
